import { render, staticRenderFns } from "./UpdateDDATForm.vue?vue&type=template&id=1a8b2f30&scoped=true"
import script from "./UpdateDDATForm.vue?vue&type=script&lang=js"
export * from "./UpdateDDATForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateDDATForm.vue?vue&type=style&index=0&id=1a8b2f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b2f30",
  null
  
)

export default component.exports